module.exports = "<div class=\"container intro-unit\">\n    <h1 class=\"display-2\">NPRB Review Portal</h1>\n    <p class=\"lead\">\n        Review Systems for the following programs:\n    </p>\n    <ul>\n        <li>AMSS Abstact Submission</li>\n        <!--<li>CORE Grant Program</li>-->\n        <!--<li>GSRA Grant Program</li>-->\n    </ul>\n    <small>Established: October, 2016</small>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/splash/splash.component.html
// module id = 901
// module chunks = 0